import { API_BASE } from '../config.js';

export type AssetCollection = 'cars' | 'drivers';
export type AssetItem = { filename: string; publicPath: string };
export type AssetLibraryResponse = {
  cars: AssetItem[];
  drivers: AssetItem[];
  counts: { cars: number; drivers: number };
};

export async function fetchAssetLibrary(): Promise<AssetLibraryResponse> {
  const res = await fetch(`${API_BASE}/api/assets`);
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(
      (err as { error?: string }).error ?? 'Erreur lors du chargement de la bibliothèque'
    );
  }
  return res.json() as Promise<AssetLibraryResponse>;
}

export async function uploadAsset(collection: AssetCollection, file: File): Promise<AssetItem> {
  const form = new FormData();
  form.append('image', file);
  const res = await fetch(`${API_BASE}/api/assets/${collection}`, {
    method: 'POST',
    body: form,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error((err as { error?: string }).error ?? "Erreur lors de l'ajout de l'asset");
  }
  return res.json() as Promise<AssetItem>;
}

export async function deleteAsset(collection: AssetCollection, filename: string): Promise<void> {
  const res = await fetch(`${API_BASE}/api/assets/${collection}/${encodeURIComponent(filename)}`, {
    method: 'DELETE',
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(
      (err as { error?: string }).error ?? "Erreur lors de la suppression de l'asset"
    );
  }
}
